import CKEditor from 'ckeditor4-react';

export const isSSR = typeof window === 'undefined';

export default CKEditor;
